(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/preferences/assets/javascripts/preferences.js') >= 0) return;  svs.modules.push('/components/casino/preferences/assets/javascripts/preferences.js');

'use strict';

let trinidad;
let accountUtils;
if (svs.isServer) {
  trinidad = require('@svenskaspelab/trinidad-core').core;
  accountUtils = trinidad.components.require('accountservices', 'utils');
}
const CASINO_PREFERENCES_LOCAL_KEY = 'casinoPreferences';
const CasinoPreferenceNames = Object.freeze({
  FAVORITES: 'favorites',
  LAST_PLAYED: 'lastPlayed',
  LAST_SEARCHED: 'lastSearched'
});
const CasinoPreferencesPaths = Object.freeze({
  GET_PREFERENCES: '/v1/casino/preferences',
  PUT_PREFERENCE: '/v1/casino/preference'
});
const createFetch = req => svs.isServer ? trinidad.svsFetch(req) : svs.core.svsFetch.create();
const toPreferenceArray = value => {
  if (typeof value !== 'string' || value.length === 0) {
    return [];
  }
  return value.split(';');
};

const fetchPreferences = async req => {
  const svsFetch = createFetch(req);
  const response = await svsFetch(CasinoPreferencesPaths.GET_PREFERENCES);
  const body = await response.json();
  if (!response.ok) {
    const error = new Error("Casino preferences fetch error ".concat(response.status, ": ").concat(response.statusText));
    error.status = response.status;
    error.errorCode = body === null || body === void 0 ? void 0 : body.errorCode;
    throw error;
  }
  return {
    favorites: toPreferenceArray(body === null || body === void 0 ? void 0 : body.favorites),
    lastPlayed: toPreferenceArray(body === null || body === void 0 ? void 0 : body.lastPlayed),
    lastSearched: toPreferenceArray(body === null || body === void 0 ? void 0 : body.lastSearched)
  };
};

const getPreferences = (req, res) => {
  if (!svs.isServer) {
    return fetchPreferences();
  }
  if (!res.locals[CASINO_PREFERENCES_LOCAL_KEY]) {
    res.locals[CASINO_PREFERENCES_LOCAL_KEY] = fetchPreferences(req);
  }
  return res.locals[CASINO_PREFERENCES_LOCAL_KEY];
};

const putPreference = async _ref => {
  let req = _ref.req,
    name = _ref.name,
    values = _ref.values;
  const svsFetch = createFetch(req);
  const response = await svsFetch(CasinoPreferencesPaths.PUT_PREFERENCE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name,
      value: values.join(';')
    })
  });
  if (!response.ok) {
    const body = await response.json();
    const error = new Error("Casino preferences put error ".concat(response.status, ": ").concat(response.statusText));
    error.status = response.status;
    error.errorCode = body === null || body === void 0 ? void 0 : body.errorCode;
    throw error;
  }
};

const isCloudPreferencesEnabledServer = async req => (await req.feature('ft-iam-no-iframe')) && (await req.feature('ft-casino-preference-cloud')) && accountUtils.hasJWTServer(req);
const isCloudPreferencesEnabledClient = async () => svs.core.detect.feature('ft-iam-no-iframe') && svs.core.detect.feature('ft-casino-preference-cloud') && svs.accountservices.utils.jwt.hasJWTClient(); 

const exported = {
  CasinoPreferenceNames,
  CasinoPreferencesPaths,
  isCloudPreferencesEnabled: svs.isServer ? isCloudPreferencesEnabledServer : isCloudPreferencesEnabledClient,
  getPreferences,
  putPreference
};
if (svs.isServer) {
  module.exports = exported;
} else {
  setGlobal('svs.components.casino.preferences', exported);
}

 })(window);